import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
    paper: {
        minWidth: 275,        
        margin: 8,
        marginBottom: 2,
        padding: 15,
        boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 5px 0 rgba(0, 0, 0, 0.19)',
    },
    image: {
        height: 75,
        width: 'auto',
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
}));

export default function HomeCard(props) {
    const classes = useStyles();

    return (  
      <Paper className={classes.paper} onClick={props.onClick}>
        <Grid container spacing={2}>
          <Grid item xs>
              <Typography variant="h5" component="h2">
                  {props.title}
              </Typography>
              <Typography color="textSecondary" variant="caption">
                  {props.subtitle}
              </Typography>  
          </Grid>    
          <Grid item>
              <div className={classes.image}>             
                <img className={classes.img} alt={"Imagem " + props.title} src={props.image} />
              </div>
          </Grid>
        </Grid>
      </Paper>
    );
}